// React
import React, { useState, useEffect, useContext, useRef } from "react";
// React
// CSS
import styles from "./Modal.module.css";
// CSS
// Images
import { shop_header } from "../../../Images/images";
// Images
// Models
import { Quiz } from "../../../Models/interfaces";
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
import Spinner from "../../../Utils/Spinner/Spinner";
import { buyQuizService } from "../../../Services/Buy/post/buyQuizService";
import { UserTokenContext } from "../../../Contexts/userToken";
import Swal from "sweetalert2";
import { showQuestionsOfBoughtQuiz } from "../../../Services/Quiz/post/showQuestionsOfBoughtQuiz";
import { SetUserQuestionContext } from "../../../Contexts/SetUserQuestionContext";
import { useNavigate } from "react-router";
import { LessonDataContext } from "../../../Contexts/LessonDataContext";
import { SetLessonDataContext } from "../../../Contexts/SetLessonDataContext";
import { toast } from "react-toastify";
import {getUserProfile_Service} from "../../../Services/Profile/get/getUserProfile_Service";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
// Models

type ModalProps = {
  setIsBuyQuizModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  quizData: Quiz | undefined;
  lessonName: string;
  subjectName: string;
};

const Modal: React.FunctionComponent<ModalProps> = ({
  setIsBuyQuizModalInScreen,
  quizData,
  lessonName,
  subjectName,
}) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);

  const [isPending, setIsPending] = useState<boolean>(false);
    const [isWalletPending, setIsWalletPending] = useState<boolean>(true);
    const [wallet, setWallet] = useState<number>(0);
    const [giftWallet, setGiftWallet] = useState<number>(0);
    const [payWithWallet, setPayWithWallet] = useState<number>(0);
    const [payWithGiftWallet, setPayWithGiftWallet] = useState<number>(0);
    const [finalPrice, setFinalPrice] = useState<number>(Number(quizData?.price) + Number(quizData?.gift_price));

  const lessonData = useContext(LessonDataContext);

  const userToken = useContext(UserTokenContext);
  const setUserQuestions = useContext(SetUserQuestionContext);

  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);

  const closeModal = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    outerRef.current.style.opacity = "0";
    innerRef.current.style.left = "100vw";

    setTimeout(() => {
      setIsBuyQuizModalInScreen(false);
    }, 500);
  };

    useEffect(() => {
        let final_price =  Number(quizData?.price) + Number(quizData?.gift_price);
        if(payWithGiftWallet){
            if(final_price > giftWallet){
                final_price -= giftWallet;
            }else{
                final_price = 0;
            }
        }
        if(payWithWallet){
            if(final_price > wallet){
                final_price -= wallet;
            }else{
                final_price = 0;
            }
        }
        setFinalPrice(final_price);
    }, [payWithWallet,payWithGiftWallet,wallet,giftWallet,quizData]);

  useEffect(() => {
    setTimeout(() => {
      if (!innerRef.current) return;
      if (!outerRef.current) return;

      outerRef.current.style.opacity = "0.7";
      innerRef.current.style.top = "0";
    }, 50);
  }, []);

    useEffect(() => {
        if(quizData?.has_paid){
            setIsWalletPending(false);
        }else{
            getUserProfile_Service(userToken)
                .then(({ data: { data } }) => {
                    setWallet(data.wallet);
                    setGiftWallet(data.gift_wallet);
                    // console.log(data);
                    setIsWalletPending(false);
                })
                .catch((err: any) => {
                    setIsWalletPending(false);
                    toast(
                        err.response.data.message ? err.response.data.message : err.message
                    );
                });
        }
    }, [userToken]);
  return (
    <div
      className={`${styles.modalContainer} fixed top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } w-screen h-screen flex items-center justify-center z-30`}
    >
      <div
        className={`${styles.outer} absolute top-0 left-0 w-screen h-screen `}
        ref={outerRef}
        onClick={closeModal}
      ></div>
      <div
        className={`${styles.inner} relative w-full bg-white p-4 flex flex-col items-end `}
        ref={innerRef}
      >
        <HelperHeader
          absoluteText="خریـــــد آزمـــــون"
          className="my-2"
          isBgWhite={true}
        />
        <div className="w-full flex items-center justify-center">
          <img src={shop_header} alt="" className="w-1/2 object-contain" />
        </div>
        <h1 className="mt-8 ">{subjectName}</h1>
        <p className="mt-4">
          <span>مبلغ اصلی : </span>
          <span>{Number(quizData?.price).toLocaleString("fa-EN")}</span>
        </p>
        <p className="mt-1">
          <span>مبلغ هدیه : </span>
          <span>{Number(quizData?.gift_price).toLocaleString("fa-EN")}</span>
        </p>
          {
              !quizData?.has_paid ?
                  (
                      <>
                          <p className="mt-6" style={{display:"flex",direction:"rtl"}}>
                              <div style={{display:"flex",alignItems:"center"}}>
                                  <input disabled={!giftWallet} className="ml-2" onChange={()=>{setPayWithGiftWallet((state) => state?0:1)}} type="checkbox"/>
                                  <label>کیف پول هدیه : </label>
                              </div>
                              <div>
                                  {isWalletPending ?
                                      (<SkeletonTheme
                                          baseColor="rgba(126, 58, 229 , 0.1)"
                                          highlightColor="rgba(126, 0, 229, 0.6)"
                                      >
                                          <Skeleton
                                              count={1}
                                              width={"40px"}
                                              height={"20px"}
                                              style={{ marginRight: "10px" }}
                                          />
                                      </SkeletonTheme>)
                                      :
                                      (<span className="mr-1">{giftWallet}</span>)
                                  }
                              </div>
                          </p>
                          <p className="mt-1" style={{display:"flex",direction:"rtl"}}>
                              <div style={{display:"flex",alignItems:"center"}}>
                                  <input disabled={!wallet} className="ml-2" onChange={()=>{setPayWithWallet((state) => state?0:1)}} type="checkbox"/>
                                  <label>کیف پول اصلی : </label>
                              </div>
                              <div>
                                  {isWalletPending ?
                                      (<SkeletonTheme
                                          baseColor="rgba(126, 58, 229 , 0.1)"
                                          highlightColor="rgba(126, 0, 229, 0.6)"
                                      >
                                          <Skeleton
                                              count={1}
                                              width={"40px"}
                                              height={"20px"}
                                              style={{ marginRight: "10px" }}
                                          />
                                      </SkeletonTheme>)
                                      :
                                      (<span className="mr-1">{wallet}</span>)
                                  }
                              </div>
                          </p>
                      </>
                  )
                  :""
          }
        <button
          className={`${styles.buyBtn} py-2 w-full mt-4 text-white rounded-xl flex items-center justify-center`}
          onClick={() => {
            if (isPending) return;
            setIsPending(true);
            if (!quizData) return;
            if (quizData.has_paid) {
              setIsPending(true);
              showQuestionsOfBoughtQuiz(userToken, String(quizData.id))
                .then(({ data: { data } }) => {
                  setIsPending(false);
                  if (!setUserQuestions) return;
                  setUserQuestions(data);
                  navigate("/quiz-maker/quiz-questions", {
                    state: {
                      lessonData: `${lessonName} ${subjectName} . `,
                    },
                  });
                })
                .catch((err) => {
                  console.log(err);
                  toast(
                    err.response.data.message
                      ? err.response.data.message
                      : err.message
                  );
                });
              return;
            }
            setIsPending(true);
            buyQuizService(userToken, String(quizData.id),payWithWallet,payWithGiftWallet).then(
              ({ data }) => {
                console.log(data);
                  if (data.url) {
                      window.location.href = data.url;
                      setIsPending(false);
                      return;
                  }

                Swal.fire({
                  icon: "success",
                  title: data.data,
                  confirmButtonText: "رفتن به آزمون",
                }).then(() => {
                  setIsPending(true);
                  showQuestionsOfBoughtQuiz(userToken, String(quizData.id))
                    .then(({ data: { data } }) => {
                      if (!setUserQuestions) return;
                      setUserQuestions(data);
                      if (!setLessonData) return;
                      setLessonData((prevState) => ({
                        ...prevState,
                        lessonName: String(
                          lessonData ? lessonData.lessonName : ""
                        ),
                      }));
                      navigate("/quiz-maker/quiz-questions", {
                        state: {
                          lessonData: `${
                            lessonData ? lessonData.lessonName : ""
                          } .`,
                          lessonName: String(
                            lessonData ? lessonData.lessonName : ""
                          ),
                        },
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                      Swal.fire({
                        icon: "error",
                        title: err.response.data.message
                          ? err.response.data.message
                          : err.message,
                      });
                    });
                });
              }
            );
          }}
          dir="rtl"
        >
          {isPending || isWalletPending  ? (
            <Spinner />
          ) : (
            <>{quizData?.has_paid ? <>رفتن به آزمون</> :
                (Number(quizData?.price) + Number(quizData?.gift_price)) === 0 ? (
                    <>استفاده ی رایگان</>
                ) : (
                <>
                    <span>پرداخت</span>
                    <span className={"mr-1 " + ((payWithWallet || payWithGiftWallet) ? 'line-through' :'')}>{Number(quizData?.price) + Number(quizData?.gift_price)} تومان</span>
                    {
                        (payWithWallet || payWithGiftWallet) ?
                            (<span className="mr-2">{finalPrice} تومان</span>) : ""
                    }
                </>
                )
            }</>
          )}
        </button>
      </div>
    </div>
  );
};

export default Modal;
